<template>
    <div class="pt15">
        <div class="sub_title">
           결제정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">결제일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.receiptDate) }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">결제수단</td>
                    <td>
                        <div class="d_block">
                            {{ returnPayRoute(orderData.payRoute) }}
                        </div>
                    </td>
                    <td class="c_t_title">결제금액</td>
                    <td>
                        <div class="d_block">
                            ￦{{ returnCommas(orderData.price) }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import numberMixins from "@/mixins/NumberMixins";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "PayInformationLayout",
    mixins: [numberMixins,dateMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderData : {}
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnPayRoute(key){
            switch (key) {
                case 1:
                    return '무통장';
                case 2:
                case 10:
                    return '카드';
                case 3:
                    return '실시간계좌이체';
                case 4:
                    return '휴대폰결제';
                case 5:
                    return '네이버페이';
                case 6:
                    return '카카오페이';
                case 7:
                    return '페이팔';
                default:
                    return '-';
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
